import Http from '../request-method.js';
import Crypto from '../../utils/utils-crypto.js';

export default {
    getMenuList(acc, pwd) {
        return Http.get('/SystemApi/GetMenuList', {});
    },
    uploadFiles(data){
        return Http.post('/SystemApi/UploadFiles',data)
    },

    getCommonMatchGroups() {
        return Http.get('/SystemApi/GetCommonMatchGroups', {});
    },

    getCommonMatchProjects(){
        return Http.get('/SystemApi/GetCommonMatchProjects');
    },
    editOprPwd(data){
        return Http.get('/SystemApi/EditOprPwd',data);
    },
    editCommonMatchGroups(data){
        return Http.post('/SystemApi/EditCommonMatchGroups',data)
    },
    editCommonMatchProjects(data){
        return Http.post('/SystemApi/EditCommonMatchProjects',data)
    },
    delCommonMatchGroups(data){
        return Http.get('/SystemApi/DelCommonMatchGroups',data);
    },
    delCommonMatchProject(data){
        return Http.get('/SystemApi/DelCommonMatchProject',data);
    },
    setDistributePointRule(data){
        return Http.get('/SystemApi/SetDistributePointRule',data);
    },
    getDistributePointRule(){
        return Http.get('/SystemApi/GetDistributePointRule');
    },
    selectAllReferee(){
        return Http.get('/SystemApi/SelectAllReferee');
    },
    createRandomCodeImage(){
        return Http.get('/SystemApi/CreateRandomCodeImage');
    },
    getConstantByType(data){
        return Http.get('/SystemApi/GetConstantByType',data);
    },
    getClientPlaceOfOrigin(){
        return Http.get('/SystemApi/GetClientPlaceOfOrigin');
    }

}